export class FeedItem {
  user: {
    id: number;
    name: string;
    surname: string;
    achievement: string;
    dealsCount: number;
    experience: string;
    photoUuid: string;
    patronymic: string | null;
    phone: string;
  };

  realProperty: {
    id: number;
    photoIdList: string[];
    virtualTourImageIdList: string[];
    housingPlanIdList: string[];
    residentialComplexId: number | null;
    residentialComplexName: string | null;
    roomsCount: number;
    totalArea: number;
    floor: number;
    floorCount: number;
    likesCount: number;
    commentsCount: number;
    address: {
      district: string | null;
      street: string | null;
      building: string | null;
      city: string | null;
    };
    viewCount: number;
  };

  application: {
    id: number;
    objectTypeId: number;
    objectPrice: number;
    reserved: boolean;
    isFavorite: boolean;
  };

  constructor(data: FeedItem) {
    this.user = {
      id: data.user.id,
      name: data.user.name,
      surname: data.user.surname,
      patronymic: data.user.patronymic,
      experience: data.user.experience,
      achievement: data.user.achievement,
      dealsCount: data.user.dealsCount,
      photoUuid: data.user.photoUuid,
      phone: data.user.phone,
    };

    this.realProperty = {
      id: data.realProperty.id,
      residentialComplexId: data.realProperty.residentialComplexId,
      residentialComplexName: data.realProperty.residentialComplexName,
      roomsCount: data.realProperty.roomsCount,
      floor: data.realProperty.floor,
      floorCount: data.realProperty.floorCount,
      housingPlanIdList: data.realProperty.housingPlanIdList ?? [],
      photoIdList: data.realProperty.photoIdList ?? [],
      virtualTourImageIdList: data.realProperty.virtualTourImageIdList ?? [],
      address: {
        district: data.realProperty.address.district,
        street: data.realProperty.address.street,
        building: data.realProperty.address.building,
        city: data.realProperty.address.city,
      },
      likesCount: data.realProperty.likesCount,
      commentsCount: data.realProperty.commentsCount,
      totalArea: data.realProperty.totalArea,
      viewCount: data.realProperty.viewCount,
    };

    this.application = {
      id: data.application.id,
      objectTypeId: data.application.objectTypeId,
      objectPrice: data.application.objectPrice,
      reserved: data.application.reserved,
      isFavorite: data.application.isFavorite,
    };
  }
}
